import React from 'react';
import {LauncherAppBarComponent} from '../app-bar/launcher-app-bar.component';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {LauncherDrawerComponent} from '../launcher-drawer/launcher-drawer.component';
import CssBaseline from '@material-ui/core/CssBaseline';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {LauncherRouterOutletComponent} from '../router-outlet/launcher-router-outlet.component';


const styles = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(0),
    },
    toolbar: theme.mixins.toolbar
});


export interface LauncherAppComponentProps extends WithStyles<typeof styles> {

}


export const LauncherAppComponent = withStyles(styles)(
    class extends LauncherComponentBase<LauncherAppComponentProps> {

        render() {
            return (
                <div className={this.props.classes.root}>
                    <CssBaseline/>
                    <LauncherAppBarComponent/>
                    {<LauncherDrawerComponent/>}

                    <main className={this.props.classes.content}>
                        <div className={this.props.classes.toolbar}></div>
                        <LauncherRouterOutletComponent/>
                    </main>


                </div>
            );
        }
    });